<app-image class="app-header-logo" name="logo" (click)="onClick()"></app-image>
